import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectCoverflow } from 'swiper/modules';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';

const ProductSlider: React.FC = () => {
  const { t } = useTranslation();

  const products = [
    {
      id: 1,
      key: 'weapons',
      image: "/silah.jpg",
      icon: "🎯"
    },
    {
      id: 2,
      key: 'armored',
      image: "/tank.jpeg",
      icon: "🛡️"
    },
    {
      id: 3,
      key: 'explosives',
      image: "/patlayici.jpeg",
      icon: "💥"
    },
    {
      id: 4,
      key: 'missiles',
      image: "/fuze.jpg",
      icon: "🚀"
    },
    {
      id: 5,
      key: 'cyber',
      image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&h=500&fit=crop",
      icon: "🔐"
    }
  ];

  return (
    <section id="products" className="section products-section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">{t('products.title')}</h2>
          <p className="section-subtitle">
            {t('products.subtitle')}
          </p>
        </motion.div>

        <Swiper
          modules={[Navigation, Pagination, Autoplay, EffectCoverflow]}
          spaceBetween={30}
          slidesPerView={1}
          navigation
          pagination={{ 
            clickable: true,
            dynamicBullets: true 
          }}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }}
          loop={true}
          centeredSlides={true}
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 2.5,
          }}
          breakpoints={{
            640: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30
            },
          }}
          className="swiper"
        >
          {products.map((product, index) => (
            <SwiperSlide key={product.id}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="product-card"
              >
                <div style={{ position: 'relative', overflow: 'hidden', borderRadius: '15px' }}>
                  <img src={product.image} alt={t(`products.items.${product.key}.title`)} />
                  <div style={{
                    position: 'absolute',
                    top: '20px',
                    right: '20px',
                    fontSize: '2.5rem',
                    background: 'rgba(255, 255, 255, 0.9)',
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
                  }}>
                    {product.icon}
                  </div>
                </div>
                <h3>{t(`products.items.${product.key}.title`)}</h3>
                <p>{t(`products.items.${product.key}.desc`)}</p>
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default ProductSlider;